import { h, Component } from 'preact';
import style from './style';

export default class About extends Component {
	render() {
		return (
			<div class={style.about}>
				<h1>Keith and Beryl Dawdry</h1>
				<h2>Studio potters</h2>
				<p>This is a story all about how</p>
				<p> my life got flipped turned upside down</p>
				<p>I'd like to take a minute just sit right there</p>
				<p>I'll tell you how I became the Prince of a town called Bel Air.</p>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/about/index.js